import { useState } from "react";
import logo from "../../assets/images/logo-blue.svg";
import FileDropContainer from "../../components/FileDropContainer/FileDropContainer";
import CustomSnackBar from "../../components/CustomSnackBar/CustomSnackBar";
import { useFileDropActions } from "../../hooks/useFileDropActions";
import { ROUTES } from "../../routes/routes";
import { CustomButton } from "../../components/CustomButton/CustomButton";
import CustomIcon from "../../components/CustomIcon/CustomIcon";
import * as Styles from "./Home.styles";
import HomeDecorations from "./components/HomeDecorations";
import { useXmlImport } from "../../hooks/useXmlImport";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";

export default function Home() {
  const { handleFileDropped, handleFileDroppedNavigation } = useFileDropActions();
  const { handleImportChangeNavigation } = useXmlImport();
  const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);

  function handleCloseSnackbar() {
    setIsSnackBarOpen(false);
  }

  return (
    <FileDropContainer
      onFileDropped={handleFileDropped}
      onDropNavigate={() => {
        handleFileDroppedNavigation(ROUTES.checking);
      }}
    >
      <Styles.Container>
        <img src={logo} alt="logo" />
        <Styles.Content>
          <Styles.DescriptionTitleContainer>
            <h1>Conferência de mercadorias simples e rápida </h1>
          </Styles.DescriptionTitleContainer>
          <Styles.DescriptionSection>
            <p>Importe o XML da nota fiscal e use um leitor de código de barras para garantir que tudo foi entregue corretamente. </p>
          </Styles.DescriptionSection>
          <Styles.ButtonSection>
            <CustomButton
              onFileChange={(event) =>
                handleImportChangeNavigation(event, () => {
                  setIsSnackBarOpen(true);
                })
              }
              endIcon={<CustomIcon Icon={FileUploadRoundedIcon} size={"var(--icon-size-md)"} color="currentColor" />}
            >
              Carregar XML
            </CustomButton>
          </Styles.ButtonSection>

          <CustomSnackBar message="Arquivo XML invalido!" open={isSnackBarOpen} onClose={handleCloseSnackbar} />

          <Styles.HintText>
            🛈 Você poderá importar um arquivo XML e iniciar a leitura dos itens com um leitor de código de barras.
          </Styles.HintText>
        </Styles.Content>
        <HomeDecorations />
      </Styles.Container>
    </FileDropContainer>
  );
}
